import React from 'react';

type InputTextIconProps = {
  icon: string;
};

export const InputTextIcon = ({ icon }: InputTextIconProps) => (
  <span className="p-inputgroup-addon">
    <i className={`pi ${icon}`}></i>
  </span>
);
